import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { Snackbar } from '@material-ui/core'

import { eventManager } from 'utils'

import './notification.css'

const Notification = () => {
  const [notification, setNotification] = useState({ open: false, message: '', success: false })

  useEffect(() => {
    let timer

    eventManager.addListener('notification', ({ success, message }) => {
      clearTimeout(timer)
      setNotification({ open: true, message, success })

      timer = setTimeout(() => setNotification({ open: false, message: '', success: false }), 1000)
    })

    return () => clearTimeout(timer)
  }, [])

  const { open, message, success } = notification

  return ReactDOM.createPortal(
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={open}
      message={message}
      className={`notification-snackbar ${success ? 'success': 'error'}`}
      success={success.toString()}
    />,
    document.getElementById('root')
  )
}

export default Notification
